import script from "./UserBox.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBox.vue?vue&type=script&setup=true&lang=js"

import "./UserBox.vue?vue&type=style&index=0&id=a74904d4&lang=scss"

const __exports__ = script;

export default __exports__